// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"95eeed9a","693":"5691d12c","862":"17e7a4b8"}[chunkId] + ".chunk.js";
};